import React, { useState } from 'react'
import { Dropdown, Space, Typography } from 'antd'
import { FormattedMessage, injectIntl } from 'react-intl'
import { DownOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import NewCourseSettingsModal from '../CoursesOverview/NewCourseSettingsModal'

export const CourseDropdown = () => {
  const [ showNewCourseSettingsModal, setShowNewCourseSettingsModal ] = useState(false)

  return (
    <>
      <NewCourseSettingsModal
        open={showNewCourseSettingsModal}
        setShowModal={setShowNewCourseSettingsModal}
        onCancel={() => setShowNewCourseSettingsModal(false)}
      />
      <Dropdown menu={{ items: [
        {
          key: 'courses',
          type: 'group',
          label: <FormattedMessage id='generic.course'/>,
          children: [
            {
              key: 'courses-overview',
              label: (
                <Link to="/courses-overview">
                  <FormattedMessage id='navigation.courses.manageCourses'/>
                </Link>
              )
            },
            {
              key: 'course',
              label: (
                <div onClick={() => setShowNewCourseSettingsModal(true)}>
                  <FormattedMessage
                    id='navigation.courses.createNewCourse'
                  />
                </div>
              )
            },
          ],
        },
      ]}}>
        <Space style={{cursor: 'pointer'}}>
          <Typography.Title level={5} style={{marginTop: '5px'}}>
            <FormattedMessage id="generic.course"/>
          </Typography.Title>
          <DownOutlined />
        </Space>
      </Dropdown>
    </>
  )
}

export default injectIntl(CourseDropdown)